export function displayPerformerName(performers, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (performers && performers.langs) {
    let matchedLangObj = performers.langs.find(langItem => langItem.locale === locale)
    // fallback to en-us if no current locale
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = performers.langs.find(langItem => langItem.locale === 'en-us')
    }
    // fallback if no current locale and no english
    if (!matchedLangObj && performers.langs.length > 0) {
      matchedLangObj = performers.langs[0]
    }
    // return matchedLangObj && matchedLangObj['last_name']
    if (matchedLangObj) {
      let nameText = matchedLangObj['last_name'] || ''
      if (matchedLangObj['first_name'] || matchedLangObj['middle_name']) {
        nameText += ', '
      }
      if (matchedLangObj['first_name']) {
        nameText += matchedLangObj['first_name']
      }
      if (matchedLangObj['middle_name']) {
        nameText += matchedLangObj['middle_name']
      }
      return nameText
    }
  }
  return '' // otherwise
}

export function displayPerformerPosition(performerPositon, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (performerPositon && performerPositon.langs) {
    let matchedLangObj = performerPositon.langs.find(langItem => langItem.locale === locale)
    // fallback to en-us if no current locale
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = performerPositon.langs.find(langItem => langItem.locale === 'en-us')
    }
    // fallback if no current locale and no english
    if (!matchedLangObj && performerPositon.langs.length > 0) {
      matchedLangObj = performerPositon.langs[0]
    }
    return matchedLangObj && matchedLangObj['name']
  }
  return ''
}

export function displayPerformerDescription(performer, localeParam) {
  const locale = (localeParam || this.$i18n.locale).toLowerCase()
  if (performer && performer.langs) {
    const langsAry = performer.langs
    let matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === locale)
    if (!matchedLangObj && locale !== 'en-us') {
      matchedLangObj = langsAry.find(item => item.locale.toLowerCase() === 'en-us')
    }
    if (!matchedLangObj && langsAry.length > 0) {
      matchedLangObj = langsAry[0]
    }
    return (matchedLangObj && matchedLangObj.description) || ''
  }
  return (performer && performer.description) || ''
}
